import { Module } from "@omnia/shared/shell/module";
import { defineDirective, IFieldsMapContainerContext, IOmniaShell, SharedFieldsService } from "./exports";
import { SeedsMap } from "./map/seedsMap";
import { ISeedsService } from "./types";
import { OmniaModuleId } from "@omnia/shared/generated/enums";
import { createFilter } from "@omnia/shared/fields/filters/filters";

export class SeedsCtrl extends Module {

    static create(): ng.IDirective {

        return defineDirective(SeedsCtrl, "app/seeds/seeds.html", { map: "=?" });

    };

    private _map: SeedsMap;

    static $inject = ["$scope", "OmniaSeedsService", "OmniaFieldsService", "OmniaShell", "OmniaFieldsMapContext"];

    constructor(
        $scope: ng.IScope,
        private seedsSvc: ISeedsService,
        private fieldsSvc: SharedFieldsService,
        shell: IOmniaShell,
        private mapCtxt: IFieldsMapContainerContext) {

        super($scope, shell, "icon-reco-seeds", "Seeds", OmniaModuleId.Seeds);

    }

    $onInit() {

        this._filter = createFilter(this.fieldsSvc)

        this.setupMap()
        this.register()
        this.startFirstComponent("omnia-seeds-menu", () => this.refresh())

    }

    $onDestroy() {
        this.map.dispose()
    }

    private setupMap() {

        this._map = new SeedsMap(this.mapCtxt);

        this._map.fieldsLayer.selectable = false;
        this._map.croppingLayer.selectable = true;

        this.$scope.$watch("vm.fieldsSvc.selectedItems", () => this._map.updateMapSelection());

        this.$scope.$watch("vm.fieldsSvc.lastLocatedItems", ({ items }: SharedFieldsService["lastLocatedItems"]) => {
            this._map.showFeaturesWithData(items, true);
        });

    }

    private register() {

        this.registerComponent("omnia-seeds-menu", {
            width: 350,
            attrs: { "map": "vm.map" }
        });


        ["plan-edit", "layer-edit", "map-calc-form"].forEach(id => {
            this.registerComponent(`omnia-seeds-${id}`, {
                width: 350,
                attrs: { "map": "vm.map" },
                restartCurrent: true
            })
        })

        this.registerComponent("omnia-datalayers-layer-edit", {
            width: 350,
            attrs: { "map": "vm.map" }
        })

    }

    refresh() {
        return this.seedsSvc.refresh()
    }

    get map(): SeedsMap {
        return this._map;
    }

    set map(value: SeedsMap) {
        this._map = value;
    }

}
